import { render } from "./discounts.vue?vue&type=template&id=6abfe7a2&scoped=true"
import script from "./discounts.vue?vue&type=script&lang=js"
export * from "./discounts.vue?vue&type=script&lang=js"

import "./discounts.vue?vue&type=style&index=0&id=6abfe7a2&scoped=true&lang=css"

import exportComponent from "C:\\src\\web\\finance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6abfe7a2"]])

export default __exports__